import { render } from "./blog-category-list.vue?vue&type=template&id=5f383c4c"
import script from "./blog-category-list.vue?vue&type=script&lang=js"
export * from "./blog-category-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__